import { IApiRequestConfig } from '../api.types';

export const searchProjectTimesApi = (week: string): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'getProjectTimes',
  uri: 'json',
  action: 'getProjectTimes',
  method: 'get',
  params: { week: week },
});
